// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"e3342a51","408":"6262a73e"}[chunkId] + ".chunk.css";
};